import { useState } from "react";
import { useLocation } from "react-router-dom";

import { RootState } from "../../../redux/store";
import { Paths } from "../../../common/constants";
import { showAlert } from "../../../common/utils";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { BankAccount } from "../../../pages/accounts-management/services/type";
import { onSetPrimaryAccount } from "../../../pages/accounts-management/services/action";

const useAccountListingHelper = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const pathName = location.pathname;
  const isAccountsPage = pathName.includes(Paths.ACCOUNT_LIST);

  const initialAccount: BankAccount = {
    bankAccountId: "",
    userId: "",
    bankName: "",
    accountLast4: "",
    name: "",
    externalBankAccountId: "",
    isSelected: "",
    accountType: "",
    status: "",
    createdDate: 0,
  };

  const [selectedAccount, setSelectedAccount] =
    useState<BankAccount>(initialAccount);

  const {
    accountListingQueryParameters,
    accountList: { accounts: accountListing },
  } = useAppSelector((state: RootState) => state.myAccount);

  const { pageNo, limit } = accountListingQueryParameters;

  const [
    openSetPrimaryConfirmationDialog,
    setOpenSetPrimaryConfirmationDialog,
  ] = useState<boolean>(false);

  const handleOpenSetPrimaryConfirmationDialog = () => {
    setOpenSetPrimaryConfirmationDialog(true);
  };

  const handleCloseSetPrimaryConfirmationDialog = () => {
    // handleClose();
    setOpenSetPrimaryConfirmationDialog(false);
  };

  const handleSetPrimaryAccount = () => {
    if (selectedAccount) {
      dispatch(
        onSetPrimaryAccount(selectedAccount.bankAccountId, () => {
          handleCloseSetPrimaryConfirmationDialog();
        }),
      );
    } else {
      showAlert(2, "Please select an account to mark as primary");
    }
  };

  /**
   * Handles menu item click for a given action
   */
  const handleMenuItemClick = (action: string, row: BankAccount) => {
    switch (action) {
      case "Mark as Primary":
        handleOpenSetPrimaryConfirmationDialog();
        break;
      default:
        break;
    }
  };

  /**
   * Handles primary action button click for a row
   */
  const handlePrimaryClick = (
    primaryAction: string | null,
    row: BankAccount,
  ) => {
    if (!primaryAction) return;

    setSelectedAccount(row);
    handleMenuItemClick(primaryAction, row);
  };

  return {
    limit,
    pageNo,
    accountListing,
    isAccountsPage,
    openSetPrimaryConfirmationDialog,

    handlePrimaryClick,
    handleMenuItemClick,
    handleSetPrimaryAccount,
    handleCloseSetPrimaryConfirmationDialog,
  };
};

export default useAccountListingHelper;
